module.exports = __webpack_public_path__ + "img/googlePlayBg.d323f298.png";